import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Typography } from '~/components/elements/Typography'
import { exists } from '~/utils'

import { type InputValues } from '../utils'

import { StrategiesInput } from './StrategiesInput'

export const StrategiesContainer = () => {
  const { t } = useTranslation()
  const { watch } = useFormContext<InputValues>()
  const [surveyId, brandGroupId, brandId] = watch([
    'surveyId',
    'brandGroupId',
    'brandId',
  ])

  if (!exists(surveyId) || !exists(brandGroupId) || !exists(brandId)) {
    return (
      <Typography variant="normal">
        {t('please_select_a_survey_brand_group_and_brand')}
      </Typography>
    )
  }

  return <StrategiesInput />
}
